export const JET_REWE_RESELLERS = ["JUST-EAT-REWE", "JUST-EAT-WEINFREUNDE", "JUST-EAT-REWEREADY"];
export const WOLT_RESELLERS = ["WOLT", "WOLT-BYOC", "WOLT-BYOC-PLUS"];
